import { GenIcon } from '../helpers/IconBase.es.js';

const AdvisoryOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M21.167 2.83325H11.167V11.1666L15.3337 7.83325H21.167V2.83325Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.3335 20.1966C10.3335 19.6933 10.1127 19.2141 9.7185 18.9016C9.116 18.4233 8.071 17.8333 6.5835 17.8333C5.096 17.8333 4.051 18.4233 3.4485 18.9016C3.05433 19.2141 2.8335 19.6933 2.8335 20.1966V21.1666H10.3335V20.1966Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.58333 15.3332C7.73393 15.3332 8.66667 14.4004 8.66667 13.2498C8.66667 12.0992 7.73393 11.1665 6.58333 11.1665C5.43274 11.1665 4.5 12.0992 4.5 13.2498C4.5 14.4004 5.43274 15.3332 6.58333 15.3332Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.167 20.1966C21.167 19.6933 20.9462 19.2141 20.552 18.9016C19.9495 18.4233 18.9045 17.8333 17.417 17.8333C15.9295 17.8333 14.8845 18.4233 14.282 18.9016C13.8878 19.2141 13.667 19.6933 13.667 20.1966V21.1666H21.167V20.1966Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M17.4168 15.3332C18.5674 15.3332 19.5002 14.4004 19.5002 13.2498C19.5002 12.0992 18.5674 11.1665 17.4168 11.1665C16.2662 11.1665 15.3335 12.0992 15.3335 13.2498C15.3335 14.4004 16.2662 15.3332 17.4168 15.3332Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { AdvisoryOutlined };
